// ----------------------------------------------------------------------------
// Component: Product Slider
// ----------------------------------------------------------------------------
//
// A list of products
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import './_product-slider.scss';



// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".product-slider-section .carousel--product-slider").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each product list slider
        $this.addClass("product-slider-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.product-slider').find(".swiper-button-prev").addClass("product-slider-btn-prev-" + index);
        $this.parents('.product-slider').find(".swiper-button-next").addClass("product-slider-btn-next-" + index);

        var swiper = new Swiper(".product-slider-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, A11y],
            slidesPerView: 2,
            spaceBetween: 13,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 4,
                    spaceBetween: 36
                }
            },

            // // Navigation arrows
            navigation: {
              nextEl: ".product-slider-btn-next-" + index,
              prevEl: ".product-slider-btn-prev-" + index
            },

            // Pagination
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: 'true'
            },
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });
    });
});
